<template>
  <div id="uploadPhotoModal" class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Upload New Photo</p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <p class="subtitle is-4" align="center">All it takes is a single photo.</p>
            <p>For best results:</p>
            <ul style="list-style-type:disc; padding-left: 25px;">
              <li>subject facing directly at camera</li>
              <li>no expression - poker face</li>
              <li>no hair or accessories covering face</li>
              <li>clearly lit from front and above</li>
            </ul>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-fullwidth" @click="showCameraModal=true; accessUserMedia();" >Proceed</button>
          <button class="button is-fullwidth" @click="$emit('close')">Cancel</button>
        </footer>
      </div>
      <cameraModal v-show="showCameraModal" @closeCanvas="accessUserMedia()" @closeCreateNewAvatarModal="$emit('close')"
      @accessCamera="accessUserMedia()" @close="showCameraModal = false;"></cameraModal>
    </div>
</template>

<script>
  import cameraModal from './cameraModal.vue'
  import Navbar from '../Navbar.vue'

  export default {
    name: 'createNewAvatarModal',
    data() {
      return {
        showCameraModal: false,
        Navbar: false,
      }
    },
    methods: {
      accessUserMedia() {
        /*
         *  Copyright (c) 2015 The WebRTC project authors. All Rights Reserved.
         *
         *  Use of this source code is governed by a BSD-style license
         *  that can be found in the LICENSE file in the root of the source
         *  tree.
         */

        'use strict'

        this.photoReady = false

        // // Put variables in global scope to make them available to the browser console.
        var video = document.getElementById('video')
        video.style.display = "block"
        var videoOverlay = document.getElementById('videoOverlay')
        videoOverlay.style.display = "block"
        var canvas = document.getElementById('canvas')
        canvas.style.display = "none"

        if (video != null) {

          video.setAttribute('autoplay', '')
          video.setAttribute('muted', '')
          video.setAttribute('playsinline', true)
          video.setAttribute('controls', true)

          var constraints = {
            audio: false,
            video: {
              facingMode: 'user'
            }
          }

          function handleSuccess(stream) {
            // window.stream = stream; // make stream available to browser console
            video.srcObject = stream
          }

          function handleError(error) {
            console.log('navigator.getUserMedia error: ', error)
          }

          navigator.mediaDevices.getUserMedia(constraints).
              then(handleSuccess).catch(handleError)
        } else {
          var video = document.createElement("video")
          video.autoplay = true

          var camera = document.getElementById('camera')
          camera.insertBefore(video, canvas)

          var canvas = document.getElementById('canvas')
          if (canvas != null) {
            document.getElementById('canvas').style.visibility = "hidden"
          }

          video.setAttribute('autoplay', '')
          video.setAttribute('muted', '')
          video.setAttribute('playsinline', true)
          video.setAttribute('controls', true)

          var constraints = {
            audio: false,
            video: {
              facingMode: 'user'
            }
          }

          function handleSuccess(stream) {
            video.srcObject = stream
          }

          function handleError(error) {
            console.log('navigator.getUserMedia error: ', error)
          }

          navigator.mediaDevices.getUserMedia(constraints).
              then(handleSuccess).catch(handleError)
        }
      },
    },
    components: {
      cameraModal: cameraModal,
      Navbar: Navbar,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
h1 {
  font-size: 20px;
}

.button {
    background-color: purple;
    color: white;
    font-weight: 600;
    font-size: 16px;
    height: 36px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    border: none;
    -o-transition: all 0.218s;
    -moz-transition: all 0.218s;
    -webkit-transition: all 0.218s;
    transition: all 0.218s;
}
.button:hover {
  background-color: white;
  color: purple;
}

#uploadPhotoModal {
  z-index: 101;
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar/createNewAvatarModal.vue